// @ts-strict-ignore
import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'

import { mediaQueryIsMobile } from '~/theme/utils/grid'
import { Heading2, Heading4 } from '~/theme/utils/typography'
import { mediaQueryIsTablet } from '~/utils/grid'
import { splitToChunks } from '~/utils/splitToChunks'

import { gt } from '~/locale'
import Link from '~/shared/atoms/Link'
import { CarouselProvider } from '~/shared/molecules/Carousel'

import {
  ButtonsContainer,
  Container,
  Heading,
  LowerBar,
  RedirectLabel,
  SliderContainer,
  StyledCarouselButton,
  StyledCarouselContent,
  StyledCarouselItem,
  TopBar,
} from './UniversalCollectionShards'
import { Props } from './UniversalCollectionTypes'
import { toReservationOffer, toRestaurant } from './UniversalCollectionUtils'

const View: React.FC<Props> = ({ restaurants = [], reservationOffers = [], rows = 1, title, showMoreUrl }) => {
  const isMobile = useMediaQuery({ query: mediaQueryIsMobile })
  const isTablet = useMediaQuery({ query: mediaQueryIsTablet })
  const splitToRestaurantItemsRows = (items: JSX.Element[], rowsNumber: number) => splitToChunks(items, rowsNumber, StyledCarouselItem)
  const [restaurantCardItems, setRestaurantCardItems] = useState(
    splitToRestaurantItemsRows([...toRestaurant(restaurants, !isTablet), ...toReservationOffer(reservationOffers)], rows)
  )

  const Redirect = () => (
    <Link href={showMoreUrl ?? ''}>
      <RedirectLabel>{gt.tp('Main Page', 'See all')}</RedirectLabel>
    </Link>
  )

  useEffect(
    () =>
      setRestaurantCardItems(
        splitToRestaurantItemsRows([...toRestaurant(restaurants, !isTablet), ...toReservationOffer(reservationOffers)], rows)
      ),
    [restaurants, reservationOffers.length, rows, isTablet]
  )

  return (
    <Container>
      <SliderContainer>
        <CarouselProvider autoPlay={false} options={{ slidesToScroll: 1, align: 'start', loop: false }}>
          <TopBar>
            {title && <Heading as={isTablet ? Heading4 : Heading2}>{title}</Heading>}

            <ButtonsContainer>
              {!isMobile && showMoreUrl && <Redirect />}
              <StyledCarouselButton />
              <StyledCarouselButton isNext />
            </ButtonsContainer>
          </TopBar>
          <StyledCarouselContent>{restaurantCardItems}</StyledCarouselContent>
        </CarouselProvider>
      </SliderContainer>
      {isMobile && (
        <LowerBar>
          <Redirect />
        </LowerBar>
      )}
    </Container>
  )
}

export default View
